// extracted by mini-css-extract-plugin
export default {"loader":"main_loader__4WTh9","spin":"main_spin__jy7EA","div":"main_div__BC-am"};